// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"1ebe8986","453":"4cb5da17","541":"000bc091","875":"8c888d81"}[chunkId] + ".chunk.js";
};